import Swal from 'sweetalert2';

const TITLE_ERROR = 'Error';
const TITLE_MENSAJE = 'Mensaje';
const MESSAGE_ALGO_SALIO_MAL = 'Lo sentimos, Algo salió mal, comunicate con soporte';
const RETRY_MESSAGE = 'Lo sentimos. {reason}. Intenta continuar con tu operación más tarde';
const MESSAGE_MONTO_MININO = 'Por favor verifica la información, no podemos realizar un pago por un valor inferior a ';
const MESSAGE_MONTO_MAXIMO = 'No puedes pagar un valor superior al adeudado actualmente ';
const MESSAGE_REDIRECCION_PSE = 'Ya tienes una transacción en proceso, te enviaremos a ella';
const MESSAGE_EXPIRE_SESSION = 'Tu sesión expiró';
const USER_NO_FOUND = 'Usuario incorrecto';
const UPS = 'Ups';
const DATES_DONT_MATCH = 'Las fechas no coinciden';
const TITLE_RESET_PASSWORD = 'Cambio de contraseña exitoso';
const MESSAGE_RESET_PASSWORD = 'Ingresa con tu correo electrónico y nueva contraseña';
const UPDATE_PROFILE = 'Actualización de Perfil';
const MENSSAGE_PENDING_SIGNATURE =
  'Tienes una solicitud previamente aprobada con Rapicredit. ¡Retómala! Sólo falta tu firma y desembolsaremos el dinero a tu billetera virtual.';
const MENSAGE_COUNTER_OFFER_ACTIVE =
  'En la última solicitud que realizaste te hicimos una oferta que no has aceptado. !Retómala y continúa el proceso!';
const ERROR_MESSAGE_ATTEMPTS = 'Has alcanzado el número máximo de intentos permitidos.';
const skipMessages = ['P-97', 'P-207', DATES_DONT_MATCH];

const showPopupBase = (title: string, message: string) => {
  return Swal.fire({
    title: title,
    confirmButtonText: 'OK',
    confirmButtonColor: '#4148F5',
    customClass: {
      popup: 'sweet-customized-popup',
      actions: 'sweet-customized-actions',
      confirmButton: 'mat-flat-button mat-primary',
    },
    text: message,
  });
};

const show_popup = (title, message) => {
  return showPopupBase(title, message).then(() => {});
};

export {
  show_popup,
  showPopupBase,
  TITLE_ERROR,
  TITLE_MENSAJE,
  MESSAGE_ALGO_SALIO_MAL,
  MESSAGE_MONTO_MININO,
  MESSAGE_MONTO_MAXIMO,
  MESSAGE_REDIRECCION_PSE,
  MESSAGE_EXPIRE_SESSION,
  USER_NO_FOUND,
  UPS,
  DATES_DONT_MATCH,
  TITLE_RESET_PASSWORD,
  MESSAGE_RESET_PASSWORD,
  RETRY_MESSAGE,
  UPDATE_PROFILE,
  MENSSAGE_PENDING_SIGNATURE,
  MENSAGE_COUNTER_OFFER_ACTIVE,
  ERROR_MESSAGE_ATTEMPTS,
};
